import ShowVM from './show-vm';
export default {
  init: function(node) {
    var $el = $('.hero');
    var colors = $el.data('colors').trim().split(/[,\s]+/);
    if (colors.length != 0 && colors[0] != '' && colors.length > 1) {
      Kadenze.UIUtil.trianglify($el, colors, 40, 2, 'rgb', 0.88);
    }
    else if (colors.length == 1) {
      $el.css('background-image', 'none');
      $el.css('background-color', colors[0]);
    }

    var courses_data = JSON.parse(node.dataset.coursesData);
    ko.applyBindingsWithValidation(new ShowVM(courses_data), node);

    Kadenze.Share.init();
    // see https://github.com/jonlunsford/share.js for more options
  }
};
